// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rxv8owHP5gEsTnth{margin:0 auto;max-width:880px}.nxyohC6h8qQiz6AW{margin:0 auto;max-width:365px;text-align:center}.HEJWgW7Z4YwQ_5Wf{margin:0 auto;max-width:288px}.HEJWgW7Z4YwQ_5Wf .m6gsiPFPAJ9lre5F{margin-top:16px}.HEJWgW7Z4YwQ_5Wf .m6gsiPFPAJ9lre5F:first-child{margin-top:0}.HEJWgW7Z4YwQ_5Wf .m6gsiPFPAJ9lre5F .mS61qLUaFnMWiqYp{margin-top:8px}.bgN45ghpEgTsTZLs{margin:0 auto;max-width:208px}.bgN45ghpEgTsTZLs .HsIafCn7Mroncivn{width:100%;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Rxv8owHP5gEsTnth`,
	"header": `nxyohC6h8qQiz6AW`,
	"formWrapper": `HEJWgW7Z4YwQ_5Wf`,
	"inputGroup": `m6gsiPFPAJ9lre5F`,
	"input": `mS61qLUaFnMWiqYp`,
	"buttonWrapper": `bgN45ghpEgTsTZLs`,
	"button": `HsIafCn7Mroncivn`
};
export default ___CSS_LOADER_EXPORT___;
